<template>
  <div>
    <div class="relative">
      <select
        v-model="hour"
        name="hours"
        id="hours"
        class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200 mb-5"
      >
        <option value="" disabled>ساعت تولد خود را وارد نمایید</option>
        <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z"
            fill="#64748B"
          />
        </svg>
      </div>
    </div>

    <div class="relative">
      <select
        v-model="min"
        name="minutes"
        id="minutes"
        class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200"
      >
        <option value="" disabled>دقیقه تولد خود را وارد نمایید</option>
        <option v-for="min in mins" :key="min" :value="min">{{ min }}</option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z"
            fill="#64748B"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'TimePicker',
  components: {
  },
  props: {
    is_pro: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hour: '',
      min: '',
      sec: 0,
      hours: this.getRange(0, 24, 1),
      mins: this.getRange(0, 60, 1),
      secs: this.getRange(0, 60, 1),
    }
  },
  watch: {
    hour(value) {
      this.updateParentTimePicker()
    },
    min(value) {
      this.updateParentTimePicker()
    },
    sec(value) {
      this.updateParentTimePicker()
    },
  },
  methods: {
    getRange(start, end, step) {
      return Array.from(
        Array.from(Array(Math.ceil((end - start) / step)).keys()),
        x => String(start + x * step).toString()
      )
    },
    updateParentTimePicker() {
      this.$emit('updateTimePickerForm', this.hour, this.min, this.sec)
    },
  },
}
</script>

<style scoped>
.input-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
}
</style>
